export default "__VITE_ASSET__Dl_t9nhc__"